import * as React from 'react'
import { on, off } from '@arsenal/arsenal/modules/event'
import { sendTeaCommEvent } from 'lib/tea-analyze'

const jumpTopIcon = require('static/jump-top.png')

interface IProps {
  bottom?: number
}

export default function BackToTop({ bottom = 0 }: IProps) {
  const [show, updateShow] = React.useState(false)
  React.useEffect(() => {
    function handleScroll() {
      const scrollElement =
        document.scrollingElement || document.documentElement
      if (scrollElement.scrollTop > 100) {
        updateShow(true)
      } else {
        updateShow(false)
      }
    }
    on(document, 'scroll', handleScroll)
    return () => {
      off(document, 'scroll', handleScroll)
    }
  }, [])
  const handleButtonClick = () => {
    sendTeaCommEvent('clk_event', {
      event_id: 'right_float_nav',
      button_name: '返回顶部',
    })
    const scrollElement = document.scrollingElement || document.documentElement
    const top = scrollElement.scrollTop
    sendTeaCommEvent('return_to_top')
    scrollSmoothly(scrollElement, -top)()
  }

  let bottomSize = 29
  // 如果有自定义的优先级更高
  if (bottom) {
    bottomSize = bottom
  }

  function renderTopButton() {
    return (
      <div
        onClick={handleButtonClick}
        className={`tw-fixed tw-rounded-2 tw-cursor-pointer tw-bg-white tw-bottom-${bottomSize} tw-z-100 tw-right-8 tw-pt-16 tw-pb-16 tw-pl-12 tw-pr-12 tw-flex tw-items-center`}
      >
        <img
          src={jumpTopIcon}
          className={`tw-mr-4 tw-h-24 tw-w-24 tw-object-cover tw-object-center`}
        />
        <p className={`tw-text-common-black tw-text-14`}>返回顶部</p>
      </div>
    )
  }

  if (!show) {
    return null
  }
  return <>{renderTopButton()}</>
}

function scrollSmoothly(scrollElement: Element, dis: number) {
  let moved = 0
  const initTop = scrollElement.scrollTop
  return function scroll() {
    if (Math.abs(moved) < Math.abs(dis)) {
      /**
       * 200ms内移动dis的距离
       * 200 / 16 得出一共要多少帧
       * dis / (200 / 16)得出每一帧移动的距离
       */
      moved = moved + dis / (200 / 16)
      if (dis > 0) {
        moved = Math.min(moved, dis)
      } else {
        moved = Math.max(moved, dis)
      }
      scrollElement.scrollTop = initTop + moved

      requestAnimationFrame(scroll)
    }
  }
}
